import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ChurnFlowSolutionIconVariant } from '@core/churn-flow-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { BadgeComponent, IconComponent } from '@core/user-interface-legacy';

import { ChurnFlowSolutionIconComponent } from '../churn-flow-solution-icon/churn-flow-solution-icon.component';

@Component({
  selector: 'tlc-churn-flow-solution-card',
  templateUrl: './churn-flow-solution-card.component.html',
  styleUrls: ['./churn-flow-solution-card.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ChurnFlowSolutionIconComponent, IconComponent, BadgeComponent, TranslatePipe],
})
export class ChurnFlowSolutionCardComponent {
  public iconVariant = input.required<ChurnFlowSolutionIconVariant>();
  public title = input.required<string>();
  public subtitle = input<string>();
  public incentives = input.required<string[]>();

  public displayFreeBadge = input<boolean>(false);
  public isHighlighted = input<boolean>(false);
}
